import { Check, X } from 'lucide-react';
import { PASSWORD_RULES, isPasswordValid } from '@/lib/passwordPolicy';

interface PasswordRequirementsProps {
  password: string;
  confirmPassword?: string;
  showMatch?: boolean;
}

export function PasswordRequirements({
  password,
  confirmPassword = '',
  showMatch = false,
}: PasswordRequirementsProps) {
  const matchOk = !showMatch || (confirmPassword.length > 0 && password === confirmPassword);

  return (
    <div className="rounded-xl border border-line bg-overlay-1 px-3.5 py-3 space-y-2">
      <p className="text-[11px] font-medium text-fg-subtle uppercase tracking-wide">
        Exigences du mot de passe
      </p>
      <ul className="space-y-1.5">
        {PASSWORD_RULES.map((rule) => {
          const ok = password.length > 0 && rule.test(password);
          return (
            <li key={rule.id} className="flex items-center gap-2 text-xs">
              {ok ? (
                <Check className="w-3.5 h-3.5 text-green-400 flex-shrink-0" />
              ) : (
                <X className="w-3.5 h-3.5 text-fg-faint flex-shrink-0" />
              )}
              <span className={ok ? 'text-green-400/90' : 'text-fg-faint'}>{rule.label}</span>
            </li>
          );
        })}
        {showMatch && (
          <li className="flex items-center gap-2 text-xs">
            {matchOk ? (
              <Check className="w-3.5 h-3.5 text-green-400 flex-shrink-0" />
            ) : (
              <X className="w-3.5 h-3.5 text-fg-faint flex-shrink-0" />
            )}
            <span className={matchOk ? 'text-green-400/90' : 'text-fg-faint'}>
              Les mots de passe correspondent
            </span>
          </li>
        )}
      </ul>
      {password.length > 0 && !isPasswordValid(password) && (
        <p className="text-[11px] text-amber-400/80 leading-relaxed">
          Choisissez un mot de passe plus sécurisé avant de continuer.
        </p>
      )}
    </div>
  );
}
